import { makeDeleteRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';

const deleteDomainUrl: string = 'ows/api/v1/PremiumDomain/';

export async function deleteDomain(): Promise<boolean> {
    let response = await makeDeleteRequest(deleteDomainUrl, undefined, undefined, true);

    if (isSuccessStatusCode(response.status)) {
        return true;
    }

    return undefined;
}
